/**
 * Compile-time literal union of all valid Contact field IDs.
 *
 * Derived from the `satisfies`-typed field maps in `./contact-fields-*.ts`.
 * Used to narrow `SavedViewConfig.visibleColumns` so typos in saved views
 * are caught by `tsc`.
 */
import { coreContactFields } from "./contact-fields-core";
import { companyContactFields } from "./contact-fields-company";
import { dealsContactFields } from "./contact-fields-deals";
import { locationContactFields } from "./contact-fields-location";
import { statusContactFields } from "./contact-fields-status";
import { metadataContactFields } from "./contact-fields-metadata";
import { extendedContactFields } from "./contact-fields-extended";
import { contractContactFields } from "./contact-fields-contract";

export const CONTACT_FIELDS = {
  ...coreContactFields,
  ...companyContactFields,
  ...dealsContactFields,
  ...locationContactFields,
  ...statusContactFields,
  ...metadataContactFields,
  ...extendedContactFields,
  ...contractContactFields,
};

/** Literal union of every valid contact field id. */
export type ContactFieldId = keyof typeof CONTACT_FIELDS;
